export const EXPERT_PROFILE_TAB = {
    INFO: 'info',
    EVALUATION: 'evaluation',
};

export const EXPERT_PROFILE_MODE = {
    VIEW: 'view',
    EDIT: 'edit',
};

export const EXPERT_PROFILE_SECTION = {
    BASIC: 'basic',
    PRO: 'pro',
    PAYMENT: 'payment',
    MORE: 'more',
};

export const getExpertProfileFooterState = ({ activeTab, mode, canEdit, hasExpertId, hasLoadError, isCreate }) => {
    if (isCreate) {
        return {
            showLeftMeta: false,
            showEditAction: false,
            showCancelEditAction: false,
            showSaveAction: activeTab === EXPERT_PROFILE_TAB.INFO && mode === EXPERT_PROFILE_MODE.EDIT,
            /** 查看态关闭抽屉（与「编辑」并列） */
            showCancelCloseAction: false,
        };
    }

    const showLeftMeta = Boolean(hasExpertId) && !hasLoadError;

    if (mode === EXPERT_PROFILE_MODE.EDIT) {
        if (hasLoadError || !hasExpertId || activeTab !== EXPERT_PROFILE_TAB.INFO) {
            return {
                showLeftMeta,
                showEditAction: false,
                showCancelEditAction: false,
                showSaveAction: false,
                showCancelCloseAction: false,
            };
        }
        return {
            showLeftMeta,
            showEditAction: false,
            showCancelEditAction: true,
            showSaveAction: true,
            showCancelCloseAction: false,
        };
    }

    // 查看态：保留「取消」关闭抽屉；专家信息 Tab 可再显示「编辑」
    const showCancelCloseAction = Boolean(hasExpertId);

    if (hasLoadError || !hasExpertId || activeTab !== EXPERT_PROFILE_TAB.INFO) {
        return {
            showLeftMeta,
            showEditAction: false,
            showCancelEditAction: false,
            showSaveAction: false,
            showCancelCloseAction,
        };
    }

    return {
        showLeftMeta,
        showEditAction: Boolean(canEdit),
        showCancelEditAction: false,
        showSaveAction: false,
        showCancelCloseAction,
    };
};

export const getExpertProfileNextStateForExpertSwitch = ({ nextExpertId }) => ({
    expertId: nextExpertId,
    activeTab: EXPERT_PROFILE_TAB.INFO,
    mode: EXPERT_PROFILE_MODE.VIEW,
    activeSection: EXPERT_PROFILE_SECTION.BASIC,
    shouldScrollToTop: true,
    shouldResetFormDraft: true,
});
